import Account, { defaultValues } from 'records/Account';
import { AssignedAccounts } from 'records/AssignedAccount';
import {
  ACCOUNT_RESET_STATE,
  ACCOUNT_ASYNC_ACTION_START,
  ACCOUNT_ASYNC_ACTION_ERROR,
  ACCOUNT_ASYNC_SET_PAGE,
  ACCOUNT_LOAD_NEW_PAGE_SUCCESS,
  ACCOUNT_LOAD_NEW_PAGE_START,
  ACCOUNT_SET_SELECTED_STATE,
} from 'actions/account';

export const initialState = new Account(defaultValues);

const actionsMap = {
  [ACCOUNT_RESET_STATE]: () => {
    return initialState;
  },
  [ACCOUNT_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
      hasInactive: false,
    });
  },
  [ACCOUNT_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      pageLoading: false,
      errorMessage: action.error,
    });
  },
  [ACCOUNT_ASYNC_SET_PAGE]: (state, action) => {
    const {
      offset,
      territories,
      accounts,
      count,
      hasMore,
      hasInactive,
    } = action.payload;

    return state.merge({
      loading: false,
      errorMessage: null,
      count,
      nextOffset: offset,
      nextTerritory: territories,
      hasMore,
      hasInactive,
      data: AssignedAccounts(accounts),
    });
  },

  [ACCOUNT_LOAD_NEW_PAGE_SUCCESS]: (state, action) => {
    const {
      offset,
      territories,
      accounts,
      hasMore,
      hasInactive,
    } = action.payload;
    const data = state.get('data').concat(AssignedAccounts(accounts));

    return state.merge({
      loading: false,
      errorMessage: null,
      nextOffset: offset,
      nextTerritory: territories,
      hasMore,
      data,
      pageLoading: false,
      hasInactive: state.get('hasInactive') || hasInactive || false,
    });
  },

  [ACCOUNT_LOAD_NEW_PAGE_START]: state =>
    state.merge({
      pageLoading: true,
    }),

  [ACCOUNT_SET_SELECTED_STATE]: (state, action) => {
    const { accountId, isSelected } = action.payload;

    const data = state.get('data').map(account =>
      account.get('accountId') === accountId ? account.set('isSelected', isSelected) : account
    );
    return state.set('data', data);
  }
}

export default function account(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
